import React, { useState } from "react";
import { ChoiceButton, PlayButton, useShuffledChoices } from "../../grammar/shared";
import { Prompt } from "./shared";

/**
 * ClozeChoiceItem — an Arabic sentence with one gap and four Arabic chips.
 * The gap is drawn as a gold underline; after the pick the full sentence is
 * shown with the answer highlighted (green) and its audio offered.
 */
export default function ClozeChoiceItem({ question, onAnswer, audio }) {
  const { data } = question;
  const [picked, setPicked] = useState(null);
  const view = useShuffledChoices(data.choices, data.correct_index ?? 0, [question.id]);
  const correct = data.choices[data.correct_index ?? 0];

  const pick = (idx) => {
    if (picked !== null) return;
    setPicked(idx);
    onAnswer({ correct: idx === view.correctIndex, answer: view.choices[idx] });
  };

  const [before, after] = data.sentence_ar.split("___");
  const revealed = picked !== null;
  return (
    <>
      <Prompt>{question.prompt_en}</Prompt>
      <div className="text-center mb-2 mt-5">
        <p dir="rtl" lang="ar" className="font-arabic text-4xl leading-[2.1] m-0 mb-1" style={{ color: "var(--parchment)" }}>
          {before}
          {revealed ? (
            <span style={{ color: picked === view.correctIndex ? "var(--teal)" : "var(--gold-bright)" }}>{correct}</span>
          ) : (
            <span className="inline-block min-w-[3ch] border-b-2 mx-1 align-baseline" style={{ borderColor: "var(--gold)" }}>&nbsp;</span>
          )}
          {after}
        </p>
        {data.sentence_en && (
          <p className="text-sm mt-2 mb-0 inline-flex items-center gap-3" style={{ color: "var(--parchment-dim)" }}>
            {data.sentence_en}
            {revealed && audio.audioAllowed && <PlayButton text={data.full_ar} playingText={audio.playingText} onPlay={audio.play} />}
          </p>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 max-w-xl mx-auto mt-4">
        {view.choices.map((choice, idx) => {
          let state = "idle";
          if (revealed) {
            if (idx === view.correctIndex) state = "correct";
            else if (idx === picked) state = "wrong";
            else state = "dim";
          }
          return (
            <ChoiceButton key={idx} arabic state={state} disabled={revealed} onClick={() => pick(idx)}>
              {choice}
            </ChoiceButton>
          );
        })}
      </div>
    </>
  );
}
